import { DocumentationVault } from "../../../components/vault/DocumentationVault.tsx";

export default function VaultIDPage() {
  return <DocumentationVault />;
}
